import { render, staticRenderFns } from "./ReportTableButtons.vue?vue&type=template&id=31961ac6&"
import script from "./ReportTableButtons.vue?vue&type=script&lang=js&"
export * from "./ReportTableButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports